import { ability } from './ability'

try {
  const rules = JSON.parse(localStorage.getItem('userAbilityRules') || '[]')
  if (Array.isArray(rules)) {
    ability.update(rules)
  }
} catch (e) {
  console.error('Failed to load ability rules:', e)
}
